module.exports = __webpack_public_path__ + "static/a-xx-155-art-999a1adfecf53d15075fd39a53a1fc66.jpg";